import { ExperienceLevel, Goals, HeardAboutUs } from "@modules/boxLead/entities/boxLeadTypes"
import { word } from "@modules/core/utils/i18n"
import { phoneRegExp } from "@modules/form/formUtils"
import * as Yup from "yup"

export type BoxLeadInputKey =
  | "userId"
  | "experienceLevel"
  | "goals"
  | "hearAboutUs"
  | "hearAboutUsSpecify"
  | "madeByStaffId"
  | "firstname"
  | "lastname"
  | "email"
  | "phoneNumberInput"
  | "phoneNumberCountryCode"
  | "note"
  | "firstContact"
  | "bestTimeToContact"

export function stepOneLeadYupValidationSchema() {
  return Yup.object({
    madeByStaffId: Yup.string().nullable(),
  })
}

export function stepTwoLeadYupValidationSchema() {
  return Yup.object({
    userId: Yup.string().optional().nullable(),
    firstname: Yup.string()
      .max(64, word("form.maximum.characters", { count: 64 }))
      .nullable()
      .optional()
      .test((value, context) => {
        if (!(context.parent.userId as string | undefined) && !value) {
          return new Yup.ValidationError(word("global.form.required"), value, context.path)
        }
        return true
      }),
    lastname: Yup.string()
      .max(64, word("form.maximum.characters", { count: 64 }))
      .nullable()
      .optional()
      .test((value, context) => {
        if (!(context.parent.userId as string | undefined) && !value) {
          return new Yup.ValidationError(word("global.form.required"), value, context.path)
        }
        return true
      }),
    experienceLevel: Yup.mixed<ExperienceLevel>().oneOf(Object.values(ExperienceLevel)),
    goals: Yup.array().of(Yup.mixed<Goals>()).nullable(),
    hearAboutUs: Yup.mixed<HeardAboutUs>().oneOf(Object.values(HeardAboutUs)),
    hearAboutUsSpecify: Yup.string()
      .max(64, word("form.maximum.characters", { count: 255 }))
      .nullable()
      .test((value, context) => {
        if ((context.parent.hearAboutUs as HeardAboutUs | undefined) === HeardAboutUs.OTHER && !value) {
          return new Yup.ValidationError(word("global.form.required"), value, context.path)
        }
        return true
      }),
    email: Yup.string()
      .email(word("global.input.email.error"))
      .max(320, word("form.maximum.characters", { count: 320 }))
      .nullable(),
    phoneNumberInput: Yup.string()
      .max(64, word("form.maximum.characters", { count: 64 }))
      .nullable()
      .test((value, context) => {
        const phoneNumber = context.parent.phoneNumberInput as string | undefined
        const phoneNumberCountryCode = context.parent.phoneNumberCountryCode as string | undefined
        if (phoneNumber && phoneNumberCountryCode) {
          const testRegex = phoneNumber.match(phoneRegExp) as RegExpMatchArray | null
          if (!testRegex) {
            return new Yup.ValidationError(word("form.required.phone"), value, context.path)
          }
        }
        return true
      }),
    phoneNumberCountryCode: Yup.string()
      .max(2, word("form.maximum.characters", { count: 2 }))
      .nullable(),
    note: Yup.string()
      .max(255, word("form.maximum.characters", { count: 255 }))
      .nullable(),
    firstContact: Yup.date().required(word("global.form.required")),
    bestTimeToContact: Yup.string().max(255, word("form.maximum.characters", { count: 255 })),
  })
}

export function addLeadYupValidationSchema(setpNumber?: number) {
  switch (setpNumber) {
    case 1:
      return stepOneLeadYupValidationSchema()
    default:
      return stepTwoLeadYupValidationSchema().concat(stepOneLeadYupValidationSchema())
  }
}
